<div class="dashboard-shell">
  @if (mobileSidebarOpen) {
    <button type="button" class="dashboard-shell__backdrop" aria-label="Close sidebar" (click)="mobileSidebarOpen = false"></button>
  }
  <aside class="dashboard-shell__sidebar" [class.dashboard-shell__sidebar--collapsed]="sidebarCollapsed" [class.dashboard-shell__sidebar--mobile-open]="mobileSidebarOpen">
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>
  <div class="dashboard-shell__content">
    <app-dashboard-header [user]="user" [currentTime]="currentTimeLabel" (menuToggle)="handleMenuToggle()" />
    <main class="dashboard-content">
      <section class="dashboard-hero">
        <div class="dashboard-hero__copy">
          <p class="dashboard-hero__eyebrow">PSOD Portal</p>
          <h2>Operational Dashboard</h2>
          <p class="dashboard-hero__text">Monitor generation, demand, outage activity, and grid performance from one dashboard.</p>
        </div>
        <div class="dashboard-hero__meta">
          <div class="dashboard-hero__pill"><span>Current time</span><strong>{{ currentTimeLabel || 'Synchronizing...' }}</strong></div>
          <div class="dashboard-hero__pill"><span>System status</span><strong>Operational</strong></div>
        </div>
      </section>

      <section class="dashboard-stats" aria-label="Outage summary">
        @for (stat of stats; track stat.id) {
          <article class="stat-card stat-card--{{ stat.tone }}"><p class="stat-card__label">{{ stat.label }}</p><strong class="stat-card__value">{{ stat.value }}</strong><p class="stat-card__delta">{{ stat.delta }} compared with previous period</p></article>
        }
      </section>

      <section class="dashboard-charts">
        <article class="chart-card chart-card--wide">
          <header class="chart-card__header"><div><p class="chart-card__eyebrow">Daily operating view</p><h3>Generation and Demand</h3></div><span class="chart-card__chip">Today</span></header>
          <div class="load-bars" aria-label="Generation and demand across the day">
            @for (point of loadTimeline; track point.label) {
              <div class="load-bars__item"><div class="load-bars__columns"><i class="load-bars__generation" [style.height.%]="chartHeight(point.generation)"></i><i class="load-bars__demand" [style.height.%]="chartHeight(point.demand)"></i></div><span>{{ point.label }}</span></div>
            }
          </div>
          <div class="chart-legend"><span><i class="chart-legend__generation"></i>Generation</span><span><i class="chart-legend__demand"></i>Demand</span></div>
        </article>
        <article class="panel-card"><header class="panel-card__header"><div><p class="chart-card__eyebrow">Current values</p><h3>Grid Snapshot</h3></div></header><div class="snapshot-grid">@for (summary of summaryCards; track summary.id) { <article class="snapshot-card"><p>{{ summary.label }}</p><strong>{{ summary.value }}</strong><span>{{ summary.note }}</span></article> }</div></article>
      </section>

      <section class="dashboard-secondary">
        <article class="panel-card"><header class="panel-card__header"><div><p class="chart-card__eyebrow">Generation composition</p><h3>Generation Mix</h3></div></header><div class="mix-list">@for (mix of generationMix; track mix.name) { <div><span>{{ mix.name }}</span><i><b [style.width.%]="mix.value"></b></i><strong>{{ mix.value }}%</strong></div> }</div></article>
        <article class="panel-card"><header class="panel-card__header"><div><p class="chart-card__eyebrow">Live operations</p><h3>Recent Activity</h3></div></header><div class="event-list">@for (event of events; track event.id) { <article class="event-item event-item--{{ event.level }}"><time>{{ event.time }}</time><div><strong>{{ event.title }}</strong><p>{{ event.detail }}</p></div></article> }</div></article>
      </section>
    </main>
  </div>
</div>
